module.exports = __webpack_public_path__ + "img/item_image_9.b7e1d59e.jpg";